import { Field } from 'formik'
import { Table } from 'src/feature/bite/component'
import { useGetCampaignProductsAll } from '../../context/useQuery'
import { useVIP } from '../../hook'
import { useIntl } from 'react-intl'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { useState } from 'react'
import { DebounceInput } from 'react-debounce-input'

type Props = {
  setSection: any
  handleBack: any
  allProducts: any
  paging: any
  pagingSet: any
}

const SelectProducts = (props: Props) => {
  const intl = useIntl()
  const { selectedCampaignProduct, selectedCampaignProductSet } = useVIP()
  const [filterList, setFilterList] = useState<any>([])

  const { isLoading } = useGetCampaignProductsAll({ filterList })

  const Tool = (text: any) => {
    if (text.length < 20) {
      return <>{text}</>
    }

    return (
      <OverlayTrigger
        placement='right'
        delay={{ show: 250, hide: 400 }}
        overlay={(props) => (
          <Tooltip id='button-tooltip' {...props}>
            {text}
          </Tooltip>
        )}
      >
        <span className='menu-link menu-center'>{text.slice(0, 20) + '...'}</span>
      </OverlayTrigger>
    )
  }

  const Columns = [
    {
      title: '',
      key: 'id',
      dataIndex: 'id',
      render: (id: any, record: any) => {
        return (
          <div className='d-flex align-items-center gap-2'>
            <Field
              type='checkbox'
              name='products'
              value={id}
              className='form-check-input'
              checked={selectedCampaignProduct?.some((item: any) => item.id === id)}
              onChange={(e: any) => {
                const { checked } = e.target
                if (checked) {
                  selectedCampaignProductSet([...selectedCampaignProduct, record])
                } else {
                  selectedCampaignProductSet(
                    selectedCampaignProduct.filter((item: any) => item.id !== id)
                  )
                }
              }}
            />
          </div>
        )
      },
    },
    {
      title: intl.formatMessage({ id: 'GLOBAL.PRODUCT.CODE' }),
      key: 'code',
      dataIndex: 'code',
      render: (text: any) => Tool(text),
    },
    {
      title: intl.formatMessage({ id: 'GLOBAL.PRODUCT.NAME' }),
      key: 'name',
      dataIndex: 'name',
      render: (text: any) => Tool(text),
    },
    {
      title: intl.formatMessage({ id: 'GLOBAL.PRODUCT.CATEGORY' }),
      key: 'category',
      dataIndex: 'category',
      render: (text: any) => Tool(text),
    },
  ]

  return (
    <>
      <div className='p-5'>
        <div className='form-group mb-5 w-50'>
          <label className='form-label fw-bold'>
            {intl.formatMessage({ id: 'GLOBAL.FILTER.SEARCH' })}
          </label>
          <DebounceInput
            debounceTimeout={500}
            type='text'
            className='form-control form-control-solid ps-13'
            placeholder={intl.formatMessage({ id: 'GLOBAL.FILTER.SEARCH.PRODUCT' })}
            onChange={(e) => {
              setFilterList([
                {
                  key: 'nm',
                  operator: 14,
                  logicalOp: 2,
                  value: [e.target.value],
                  childFilters: [
                    {
                      key: 'SkuID',
                      operator: 14,
                      logicalOp: 2,
                      value: [e.target.value],
                      childFilters: [],
                    },
                    {
                      key: 'brcd',
                      operator: 14,
                      logicalOp: 2,
                      value: [e.target.value],
                      childFilters: [],
                    },
                  ],
                },
              ])
            }}
          />
        </div>
        <Table
          loading={isLoading}
          dataSource={props.allProducts}
          columns={Columns}
          pagination={{
            current: props.paging.currentPageNumber,
            pageSize: props.paging.pageSize,
            total: props.paging.totalCount,
            onChange: (pagination: { current: number; pageSize: number; total: number }) => {
              if (!props || !props.allProducts) return

              const { pageSize, current } = pagination
              const currentPage = pageSize !== props.paging.pageSize ? 1 : current

              props.pagingSet({
                ...props.paging,
                currentPageNumber: currentPage,
                pageSize: pageSize,
              })
            },
          }}
        />
      </div>
      <div className='p-5 d-flex justify-content-end'>
        <button
          className='btn btn-primary'
          onClick={() => {
            props.handleBack()
            props.setSection(1)
          }}
        >
          <span className='d-flex align-items-center gap-2'>
            {/* <i className='bi bi-arrow-left'></i> */}
            <span>{intl.formatMessage({ id: 'GLOBAL.ADD' })}</span>
          </span>
        </button>
      </div>
    </>
  )
}

export default SelectProducts
